<template>
  <div>
    <p>Сумма в заявке <strong>{{ order.price }}</strong></p>
    <p>Реквизиты привязаны к заявке на сумму <strong>{{ order.no_cash_price }}</strong></p>
    <div class="alert alert-info">
      <p>Заявка закрыта за наличные, но есть реквизиты к оплате по б/н и привязаны оплаты</p>
      <p>Рекомендации</p>
      <ul>
        <li>отвязать оплату, если она не принадлежит этой заявке</li>
        <li>выяснить как закрыта заявка, за наличные или по б/н</li>
      </ul>
    </div>
<!--    {{ order}}-->
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['order'],
  components: {},
  data() {
    return {}
  }
}
</script>
